/**
 * @description The widthType attribute is used to support fixed with media single
 */

export var WidthType = /*#__PURE__*/function (WidthType) {
  WidthType["PIXEL"] = "pixel";
  WidthType["PERCENTAGE"] = "percentage";
  return WidthType;
}({});